export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err, _instance, info) => {
    if (info !== 'setup function') return

    const status = (err as { statusCode?: number })?.statusCode ?? 0

    if (status === 401 || status === 500) return

    if (status === 403 || status === 404) {
      showError({ statusCode: 404, message: 'Página não encontrada', fatal: false })
      return
    }

    showError({ statusCode: 503, message: (err as Error)?.message || 'Falha ao carregar', fatal: false })
  }
})
